module.exports = __webpack_public_path__ + "media/images/logos/stretchlab-logo-c01639c15f305ce03be80381286c6843.svg";